"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositionsRenderer = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const helpers_1 = require("../helpers");
const composition_renderer_1 = require("./composition-renderer");
const log_1 = require("../log");
const compositionDebug = log_1.jrlDebug.extend('compositions');
const CompositionsRenderer = ({ services, renderPathPrefix, componentRegistrations, compositionRegistrations, componentMiddleware, compositionMiddleware, compositions, layoutApi, }) => {
    compositionDebug('Rendering compositions: %o', {
        renderPathPrefix,
        compositions: compositions.map(composition => ({
            type: composition.type,
        })),
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, compositions.map((composition, index) => {
        const componentRenderPath = helpers_1.getComponentPath({
            subpath: composition.type,
            index,
            prefix: renderPathPrefix,
        });
        return (react_1.default.createElement(composition_renderer_1.CompositionRenderer, { key: composition.renderKey || index, componentRenderPath: componentRenderPath, componentRegistrations: componentRegistrations, compositionRegistrations: compositionRegistrations, composition: composition, layoutApi: layoutApi, services: services, componentMiddleware: componentMiddleware, compositionMiddleware: compositionMiddleware, additionalComponentProps: {} }));
    })));
};
exports.CompositionsRenderer = CompositionsRenderer;
exports.CompositionsRenderer.displayName = 'CompositionsRenderer';
//# sourceMappingURL=compositions-renderer.js.map